import React from 'react';
import { Card, Table, Input, Button, Space, message, Tag } from 'antd';
import { SaveOutlined, ReloadOutlined } from '@ant-design/icons';
import axios from 'axios';

function authHeader() {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export default function Settings({ user }) {
  const [loading, setLoading] = React.useState(false);
  const [rows, setRows] = React.useState([]);
  const [drafts, setDrafts] = React.useState({});

  const loadSettings = React.useCallback(async () => {
    try {
      setLoading(true);
      const res = await axios.get('/api/settings', { headers: authHeader() });
      const data = res.data?.settings || [];
      setRows(data);
      const map = {};
      data.forEach((r) => { map[r.setting_key] = r.setting_value; });
      setDrafts(map);
    } catch {
      message.error('No se pudo cargar configuracion');
    } finally {
      setLoading(false);
    }
  }, []);

  React.useEffect(() => {
    loadSettings();
  }, [loadSettings]);

  const saveSetting = async (key) => {
    try {
      setLoading(true);
      await axios.put(`/api/settings/${key}`, { value: drafts[key] }, { headers: authHeader() });
      message.success(`Configuracion ${key} guardada`);
      await loadSettings();
    } catch (err) {
      message.error(err.response?.data?.error || `No se pudo guardar ${key}`);
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    { title: 'Clave', dataIndex: 'setting_key', key: 'setting_key', width: 240 },
    {
      title: 'Valor',
      key: 'value',
      render: (_, row) => (
        <Input
          value={drafts[row.setting_key] ?? ''}
          onChange={(e) => setDrafts((prev) => ({ ...prev, [row.setting_key]: e.target.value }))}
          disabled={user?.role !== 'admin'}
        />
      )
    },
    {
      title: 'Actualizado',
      dataIndex: 'updated_at',
      key: 'updated_at',
      width: 180,
      render: (v) => v || '-'
    },
    {
      title: 'Accion',
      key: 'action',
      width: 140,
      render: (_, row) => (
        <Button
          type="primary"
          icon={<SaveOutlined />}
          disabled={user?.role !== 'admin'}
          onClick={() => saveSetting(row.setting_key)}
        >
          Guardar
        </Button>
      )
    }
  ];

  return (
    <div>
      <h1 style={{ marginBottom: 20 }}>Configuracion</h1>
      <Space style={{ marginBottom: 16 }}>
        <Button icon={<ReloadOutlined />} onClick={loadSettings} loading={loading}>Actualizar</Button>
        <Tag color={user?.role === 'admin' ? 'green' : 'blue'}>{user?.role === 'admin' ? 'Modo Administrador' : 'Solo Lectura'}</Tag>
      </Space>

      <Card>
        <Table
          rowKey="setting_key"
          loading={loading}
          columns={columns}
          dataSource={rows}
          pagination={false}
        />
      </Card>
    </div>
  );
}
